import React, { useContext, useEffect, useState } from 'react';
import { Button, Card, CardBody, CardFooter, CardHeader, Col, Form, FormFeedback, Input, Label, Row, Spinner, Table } from 'reactstrap';
import { GlobalStore } from '../../../StateStores';
import { clearVehicleInspection, fetchVehicleStatus, getPendingVehicleInspection } from '../../../Actions/InspectionActs';
import Swal from 'sweetalert2';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { postInvoice } from '../../../Actions/InvoiceActs';

const CreateInvoice = ()=>{
    const navigate = useNavigate();
    const [formVehicleValid, setFormVehicleValid] = useState(false);
    const [formVehicle,setFormVehicle] = useState({plate_number:''});
    const [formVehicleErrors,setFormVehicleErrors] = useState({
        plate_number:'Plate number is required',
    });
    const [form,setForm] = useState({payment_period:3,amount:100});
    const [formErrors,setFormErrors] = useState({
        payment_period:'Payment period is required',
    });
    const [vehicleData,setVehicleData] = useState({});
    const [vehicleInsuranceData,setVehicleInsuranceData] = useState({});

    const {
        InspectionDispatch,InspectionState:{
        fetchVehiclePendingInspection:{error,loading,data},
    },InvoiceDispatch,InvoiceState:{
        postInvoice:{error:postInvoiceError,loading:postInvoiceLoading,data:postInvoiceData},
    }} = useContext(GlobalStore);

    useEffect(() => {
        const isValid = Object.values(formVehicleErrors).every(item => !item);
        setFormVehicleValid(isValid);
    }, [formVehicleErrors]);

    const onChangeVehicle = ({name,value}) => {
        if(name === 'plate_number') value = value.toUpperCase();
        
        setFormVehicle((prev) => ({ 
            ...prev, 
            [name]: value,
            amount:value
         }));
        if (value) {
            setFormVehicleErrors(prev => ({ ...prev, [name]: '' }));
        } else {
            setFormVehicleErrors(prev => ({ ...prev, [name]: 'This field is required' }));
        }
    }

    const onChangePayment = ({name,value}) => {

        let amount;
        let inputValue = parseInt(value)

        if(name === 'payment_period'){
            if(inputValue === 3){
                amount = 500;
            }else if(inputValue === 6){
                amount = 1000;
            }else if(inputValue === 12){
                amount = 2000;
            }
        }

        setForm((prev) => ({ 
            ...prev, 
            [name]: value,
            amount:amount }));

        if (value) {
            setFormErrors(prev => ({ ...prev, [name]: '' }));
        } else {
            setFormErrors(prev => ({ ...prev, [name]: 'This field is required' }));
        }
    }


    const onSubmitPlateNumber = async (e) => {
        e.preventDefault();
    
        if (formVehicleValid) {
            try {
                const response = await fetchVehicleStatus({
                    ...formVehicle,
                    insurance_data:'notfetch'
                })(InspectionDispatch);
                
                if (response.status) {
                    const { vehicle} = response.data;
                    setVehicleData(vehicle);
                } else {
                    toast.error(response.message);
                }
            } catch (error) {
                toast.error('An error occurred: ' + error.message);
            }
        }
    };

    const createTransaction = async ()=>{
        try {

            const response = await postInvoice({
                ...form,
                ...vehicleData
            })(InvoiceDispatch) 

            if(response.status){
                toast.success(response.message);
                clearVehicleInspection(InspectionDispatch)
                setVehicleData({})
                setFormVehicle({plate_number:''})
                setFormVehicleErrors({plate_number:'Plate number is required',});
            }
        } catch (error) {
            toast.error(error.message)
        }
    }
    
    //3 - 10000
    //6 - 200
    //12 -- 4000

    return(
        <React.Fragment>

            {Object.keys(vehicleData).length === 0? (
                <Form onSubmit={onSubmitPlateNumber}>
                    <React.Fragment>
                        <CardBody>
                            <Row>
                                <Col>
                                    <Label>Enter plate number</Label>
                                    <Input 
                                        type='text' 
                                        placeholder='Enter vehicle No. e.g T133ABC'
                                        value={formVehicle?.plate_number}
                                        onChange={(e) => onChangeVehicle({name:'plate_number',value:e.target.value})}
                                        valid={formVehicleErrors.plate_number === ''}
                                        invalid={formVehicleErrors.plate_number !== ''}
                                    />
                                    {formVehicleErrors.plate_number && <FormFeedback>{formVehicleErrors.plate_number}</FormFeedback>}
                                </Col>
                            </Row>
                        </CardBody>
                        <CardFooter>
                            <div className='d-flex justify-content-end mt-1'>
                                <Button disabled={!formVehicleValid} size='sm'>
                                    {loading && <Spinner size="sm"/>}
                                    <span className='ms-1'>Fetch data</span>
                                </Button>
                            </div>
                        </CardFooter>
                    </React.Fragment>
                </Form>
            ):(
                <React.Fragment>
                    <Card className='shadow-sm'>
                        <CardHeader>Vehicle Details</CardHeader>
                        <CardBody>

                            {Object.keys(vehicleData).length > 0? (

                                <Table>
                                    <tr>
                                        <th>Owner:</th>
                                        <td className='text-end text-muted'>{vehicleData?.owner}</td>
                                    </tr>
                                    <tr>
                                        <th>RegNo:</th>
                                        <td className='text-end text-muted'>{vehicleData?.regno}</td>
                                    </tr>
                                    <tr>
                                        <th>Tin:</th>
                                        <td className='text-end text-muted'>{vehicleData?.tin}</td>
                                    </tr>
                                    <tr>
                                        <th>Address:</th>
                                        <td className='text-end text-muted'>{vehicleData?.address}</td>
                                    </tr>
                                    <tr>
                                        <th>Vehicle:</th>
                                        <td className='text-end text-muted'>{vehicleData?.vehicle}</td>
                                    </tr>
                                    <tr>
                                        <th>EngineNo:</th>
                                        <td className='text-end text-muted'>{vehicleData?.engineno}</td>
                                    </tr>
                                    <tr>
                                        <th>ChassisNo:</th>
                                        <td className='text-end text-muted'>{vehicleData?.chassisno}</td>
                                    </tr>
                                    <tr>
                                        <th>Desc:</th>
                                        <td className='text-end text-muted'>{vehicleData?.titledesc}</td>
                                    </tr>
                                    <tr>
                                        <th>Mobile:</th>
                                        <td className='text-end text-muted'>{vehicleData?.mobile}</td>
                                    </tr>
                                    <tr>
                                        <th>Driver:</th>
                                        <td className='text-end text-muted'>{vehicleData?.tdriver}</td>
                                    </tr>
                                </Table>

                            ):(
                                <React.Fragment>
                                    {loading && (
                                        <div className='d-flex justify-content-center'>
                                            <Spinner size="sm"/>
                                        </div>
                                    )}
                                    {!loading && <small className='text-danger text-center'>* No details to display, Enter plate number to see details</small>}
                                </React.Fragment>
                            )}
                            
                        </CardBody>
                        <CardFooter>
                            <Row>
                                <Col>
                                    <Label>Payment period</Label>
                                    <Input 
                                        type='select'
                                        value={form?.payment_period}
                                        onChange={(e) => onChangePayment({name:'payment_period',value:e.target.value})}
                                        valid={formErrors.payment_period === ''}
                                        invalid={formErrors.payment_period !== ''}
                                    >
                                        <option value={3}>3 Months</option>
                                        <option value={6}>6 Months</option>
                                        <option value={12}>12 Months</option>
                                    </Input>
                                    {formErrors.payment_period && <FormFeedback>{formErrors.payment_period}</FormFeedback>}
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Label>Amount</Label>
                                    <Input 
                                        type='number'
                                        value={form?.amount}
                                        readOnly
                                        className='bg-light'
                                        onChange={(e) => onChangeVehicle({name:'amount',value:e.target.value})}/>
                                    {formErrors.amount && <FormFeedback>{formErrors.amount}</FormFeedback>}
                                </Col>
                            </Row>
                            <Row className='mt-3'>
                                <Col>
                                    <div className='d-flex justify-content-end'>
                                        <Button 
                                            // disabled={!formVehicleValid} 
                                            onClick={createTransaction}
                                            size='sm'>
                                            {postInvoiceLoading && <Spinner size="sm"/>}
                                            <span className='ms-1'>Create transaction</span>
                                        </Button>
                                    </div>
                                </Col>
                            </Row>
                        </CardFooter>
                    </Card>
                </React.Fragment>
            )}
            
        </React.Fragment>
    )
}

export default CreateInvoice;